exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".icon-button__main{\n  border: 1px solid rgba(40, 166, 222, 0.05);\n  border-radius: 7px;\n  padding: 3px;\n  color: rgba(43, 60, 147, 1);\n  display: -ms-flexbox;\n  display: flex;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Buttons/IconButton.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Buttons/IconButton.css
// module chunks = 120